import * as React from "react"
import { Link } from "gatsby"
import { MdExpandMore } from "react-icons/md"
import * as ui from "gatsby-ui"
import { useMatchMedia } from "../../components/shared/hooks"
import Search from "./search"
import * as styles from "./styles/subnav.css"
import { container } from "./styles/index.css"

import { join } from "."

const Spacer = (props: React.HTMLProps<HTMLDivElement>) => (
  <div {...props} className={styles.spacer} />
)

export interface SubNavLink {
  name: string
  to: string
}

export interface SubNavProps {
  title: string
  rootPath: string
  links: SubNavLink[]
  rightElement?: React.ReactNode
  searchType?: string
  withBanner?: boolean
}

export default function SubNav({
  title,
  rootPath,
  links = [],
  rightElement,
  withBanner = false,
}: SubNavProps) {
  // Mobile disclosure
  const [open, setOpen] = React.useState(false)
  const dropdownRef = React.useRef<HTMLButtonElement | null>(null)
  const isMobile = useMatchMedia(ui.media.mobileOnly)

  const isMenuVisible = open || !isMobile

  const handleBodyClick = (e: MouseEvent) => {
    if (dropdownRef?.current?.contains(e.target as HTMLElement)) return
    setOpen(false)
  }

  React.useEffect(() => {
    document.body.addEventListener("click", handleBodyClick)
    return () => {
      document.body.removeEventListener("click", handleBodyClick)
    }
  }, [])

  return (
    <div className={join(styles.root, withBanner && styles.rootShifted)}>
      <div className={join(container, styles.container)}>
        <div className={styles.left}>
          <h2 className={styles.heading}>
            <Link to={rootPath} className={styles.headingLink}>
              {title}
            </Link>
            <button
              ref={dropdownRef}
              onClick={() => {
                setOpen(!open)
              }}
              className={styles.headingChevron}
            >
              <MdExpandMore />
            </button>
          </h2>
          <div
            className={join(
              styles.navLinks,
              !isMenuVisible && styles.navLinksClosed
            )}
          >
            {links.map(({ name, ...link }) => (
              <Link key={link.to} {...link} className={styles.navLink}>
                {name}
              </Link>
            ))}
            {rightElement}
            <Spacer />
          </div>
        </div>
        <div className={styles.searchAndCTA}>
          <Search />
          <Link
            to="https://app.netlify.com/signup"
            className={styles.ctaButton}
          >
            Sign Up
          </Link>
        </div>
      </div>
    </div>
  )
}
